import { useI18n } from 'vue-i18n'
import { inject, ref } from 'vue'
import axios from 'axios'
import { useMutation } from '@tanstack/vue-query'

export default function useImageUpload() {
  const progress = ref(0)
  const imageSrc = ref('')

  const toast = <Toast>inject('ksToast')
  const { t } = useI18n()

  const uploadImageFn = async (event: Event) => {
    const target = event.target as HTMLInputElement
    if (!target.files || target.files.length === 0)
      return

    const image = target.files[0]
    const form = new FormData()

    form.append('absolute_url', '1')
    form.append('file', image)

    const response = await axios.post('/image/upload', form, {
      baseURL: import.meta.env.VITE_AUNIVERS_SITEURL,
      withCredentials: true,
      headers: {
        'Content-Type': image.type,
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          progress.value = Math.round((progressEvent.loaded / progressEvent.total) * 100)
        }
      },
    })

    imageSrc.value = response.data.src
  }

  const uploadImage = useMutation({
    mutationFn: uploadImageFn,
    onSettled: (_, error) => error
      ? toast.error(t('formWriter.toasts.imageUploadError'))
      : toast.success(t('formWriter.toasts.imageUpload')),
  })

  const reset = () => {
    progress.value = 0
    imageSrc.value = ''
  }

  return {
    uploadImage,
    progress,
    imageSrc,
    reset,
  }
}
